import { render, staticRenderFns } from "./swiper-slide.vue?vue&type=template&id=43679066"
import script from "./swiper-slide.vue?vue&type=script&lang=js"
export * from "./swiper-slide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports